const art = (f) => `/art/${f}.webp`;
const strip = (prefix, kind, items) =>
  items.map(([slug, label]) => ({ slug, label, src: art(`${prefix}-${kind}-${slug}`) }));

export const CHARACTERS = [
  {
    slug: "handy",
    name: "Handy",
    role: "Hero",
    tagline: "It's Good to Have Clean Hands!",
    type: "Friendly, animated hand",
    look: "Pudgy, doughy, five rounded fingers",
    personality: "Cheerful, curious, playful, helpful and kind",
    bio: "Handy is a bright blue, squishy hand who loves splashing at the sink. He's always ready to wave hello, count to five, and show everyone how good it feels to have clean hands.",
    signature: { title: "Wash Hands!", line: "It's good to have clean hands!", src: art("handy-pose-wash") },
    theme: { main: "#1E9BF0", deep: "#0B4FA3", soft: "#E0F2FE", accent: "#FF9EB5", ink: "#0B2A5B" },
    portrait: art("handy-portrait"),
    sheet: art("handy-sheet"),
    expressions: strip("handy", "exp", [["happy", "Happy"], ["excited", "Excited"], ["curious", "Curious"], ["surprised", "Surprised"], ["thinking", "Thinking"], ["winking", "Winking"], ["laughing", "Laughing"], ["big-smile", "Big Smile"]]),
    poses: strip("handy", "pose", [["wave", "Wave Hello!"], ["thumbs-up", "Thumbs Up!"], ["point", "Point!"], ["dance", "Dance!"], ["teach", "Teach / Explain"], ["count", "Count (1–5)"], ["wash", "Wash Hands!"]]),
  },
  {
    slug: "soapy",
    name: "Soapy",
    role: "Handy's Bubble Maker",
    tagline: "Handy's Bubble Maker!",
    type: "Soap bar (the Bubble Maker)",
    look: "Friendly, rounded bar of soap with fluffy bubbles",
    personality: "Fun, enthusiastic, a little clumsy, and loves making bubbles!",
    bio: "Soapy is a soft, smiley bar of soap with a fluffy bubble hairdo. A little clumsy but always excited, Soapy teams up with Handy and Splashy to get hands squeaky clean.",
    signature: { title: "Making Bubbles!", line: "Squeaky Clean!", src: art("soapy-pose-bubbles") },
    theme: { main: "#38A8F0", deep: "#5B3FC4", soft: "#F4FAFF", accent: "#FF9EB5", ink: "#2B2470" },
    portrait: art("soapy-portrait"),
    sheet: art("soapy-sheet"),
    expressions: strip("soapy", "exp", [["happy", "Happy"], ["excited", "Excited"], ["surprised", "Surprised"], ["curious", "Curious"], ["thinking", "Thinking"], ["laughing", "Laughing"], ["winking", "Winking"], ["proud", "Proud"]]),
    poses: strip("soapy", "pose", [["bubbles", "Making Bubbles"], ["scrubbing", "Scrubbing (with Handy)"], ["team-up", "Team Up (with Splashy)"], ["riding", "Riding a Bubble"], ["squeaky", "Squeaky Clean!"]]),
  },
  {
    slug: "germy",
    name: "Germy",
    role: "Villain",
    tagline: "Handy's Mischievous Germ!",
    type: "Germ (the playful troublemaker)",
    look: "Round, squishy, bouncy, with soft spikes and colorful spots",
    personality: "Mischievous, silly, and always looking for a place to hide",
    bio: "Germy is a giggly green germ with purple spots who loves hiding on hands and doorknobs. He shows up to cause a little trouble, and reminds us why it's so important to wash our hands!",
    signature: { title: "Washing Away!", line: "Bye-bye, Germy!", src: art("germy-pose-washing") },
    theme: { main: "#7CC61E", deep: "#5B21B6", soft: "#F3FBE6", accent: "#A855F7", ink: "#2E1065" },
    portrait: art("germy-portrait"),
    sheet: art("germy-sheet"),
    expressions: strip("germy", "exp", [["mischievous", "Mischievous"], ["laughing", "Laughing"], ["surprised", "Surprised"], ["sneaky", "Sneaky"], ["oops", "Oops!"], ["frustrated", "Frustrated"], ["silly", "Silly"]]),
    poses: strip("germy", "pose", [["hiding", "Hiding"], ["running", "Running"], ["dodging", "Dodging"], ["stuck", "Stuck in Bubbles"], ["washing", "Washing Away!"]]),
  },
];

CHARACTERS.splice(2, 0, {
  slug: "splashy",
  name: "Splashy",
  role: "Handy's Water Buddy",
  tagline: "Handy's Water Buddy!",
  type: "Water droplet (Handy's water buddy)",
  look: "Round, glossy droplet with a playful tip on top, arms and feet made of water",
  personality: "Energetic, friendly, and always ready to rinse, splash, and help",
  bio: "Splashy is a bouncy, glossy water droplet who jumps straight out of the faucet. Always full of energy, Splashy teams up with Handy and Soapy to rinse away germs and keep hands clean.",
  signature: { title: "Rinsing Germy!", line: "Splish, splash, rinse away!", src: art("splashy-pose-rinsing") },
  theme: { main: "#3BAAF2", deep: "#0A5FB4", soft: "#E6F4FF", accent: "#FF9EB5", ink: "#073B75" },
  portrait: art("splashy-portrait"),
  sheet: art("splashy-sheet"),
  expressions: strip("splashy", "exp", [["happy", "Happy"], ["excited", "Excited"], ["curious", "Curious"], ["surprised", "Surprised"], ["thinking", "Thinking"], ["winking", "Winking"], ["laughing", "Laughing"], ["cheerful", "Cheerful"]]),
  poses: strip("splashy", "pose", [["jumping", "Jumping"], ["spinning", "Spinning"], ["spraying", "Spraying"], ["team-up", "Team Up"], ["rinsing", "Rinsing Germy"]]),
});

export const SITE_DOMAIN = "HandyAndFriends.com";
export const CARTOON = { src: "/cartoon/handy-and-friends-intro.mp4?v=2", poster: "/cartoon/welcome.jpg", loop: "/cartoon/welcome-loop.mp4" };

export const COLORING_PAGES = [
  { slug: "handy", name: "Handy", preview: "/coloring/book-p2.jpg", pdf: "/coloring/book-page-2.pdf" },
  { slug: "germy", name: "Germy", preview: "/coloring/book-p3.jpg", pdf: "/coloring/book-page-3.pdf" },
  { slug: "soapy", name: "Soapy", preview: "/coloring/book-p4.jpg", pdf: "/coloring/book-page-4.pdf" },
  { slug: "splashy", name: "Splashy", preview: "/coloring/book-p5.jpg", pdf: "/coloring/book-page-5.pdf" },
];

export const COLORING_BOOK_PDF = "/coloring/Handy-and-Friends-Book-1-Coloring-Adventure.pdf";
export const COLORING_BOOK_COVER = "/coloring/book-p1.jpg";
export const CONTACT_EMAIL = "hello@handyandfriends.com";

export const getCharacter = (slug) => CHARACTERS.find((c) => c.slug === slug);
